<script lang="ts">
	import Link from '#components/link.svelte'
	import type { Blok, Link as ILink } from '#library/components.schema.build.ts'

	interface Props {
		blok: Blok<ILink>
		large?: boolean
		medium?: boolean
		small?: boolean
		subtitle?: string
	}

	let { blok, large, medium, small, subtitle }: Props = $props()
</script>

{#if blok.link?.url}
	<Link
		href={blok.link?.url}
		text={blok.link?.text ?? ''}
		target={blok.link?.target}
		{subtitle}
		{large}
		{medium}
		{small}
		{...blok.download && { download: blok.download }}
	/>
{/if}
